import React, { useEffect, useRef } from 'react';

import { useAnimation } from 'framer-motion';

import { ChipMember } from '@pkg/components';

import { Label, Link, Links, Marquee, Track, Wrapper } from './Footer.style';

export function Footer() {
    const controls = useAnimation();
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const containerWidth = containerRef.current?.offsetWidth || 0;
        const speed = 50;
        const duration = containerWidth / speed;

        controls.start({ x: '-50%', transition: { duration, ease: 'linear', repeat: Infinity } });
    }, [controls]);

    return (
        <Wrapper>
            <Label>Recently Created Yats</Label>

            <Marquee>
                <Track ref={containerRef} animate={controls}>
                    <ChipMember yat={`🐐🐐➕➕`} size={'large'} />
                    <ChipMember yat={`➕➕🐐🐐`} size={'large'} />
                    <ChipMember yat={`⭐⭐➕➕`} size={'large'} />
                    <ChipMember yat={`➕➕⭐⭐`} size={'large'} />

                    <ChipMember yat={`🐐🐐➕➕`} size={'large'} />
                    <ChipMember yat={`➕➕🐐🐐`} size={'large'} />
                    <ChipMember yat={`⭐⭐➕➕`} size={'large'} />
                    <ChipMember yat={`➕➕⭐⭐`} size={'large'} />

                    <ChipMember yat={`🐐🐐➕➕`} size={'large'} />
                    <ChipMember yat={`➕➕🐐🐐`} size={'large'} />
                    <ChipMember yat={`⭐⭐➕➕`} size={'large'} />
                    <ChipMember yat={`➕➕⭐⭐`} size={'large'} />

                    <ChipMember yat={`🐐🐐➕➕`} size={'large'} />
                    <ChipMember yat={`➕➕🐐🐐`} size={'large'} />
                    <ChipMember yat={`⭐⭐➕➕`} size={'large'} />
                    <ChipMember yat={`➕➕⭐⭐`} size={'large'} />
                </Track>
            </Marquee>

            <Links>
                <Link href="https://legal.y.at/privacy-policy" target="_blank" rel="noreferrer">
                    Privacy Policy
                </Link>
                <Link href="https://legal.y.at/terms" target="_blank" rel="noreferrer">
                    Terms of Service
                </Link>
                <Link href="https://legal.y.at/disclosure" target="_blank" rel="noreferrer">
                    Disclosure
                </Link>
                <Link href="https://emojis.y.at/support" target="_blank" rel="noreferrer">
                    Help
                </Link>
            </Links>
        </Wrapper>
    );
}
